import axios from 'axios';
import { previewMode, previewAdapter } from '../mobile/preview';

// Browser credentials never leave the current origin or enter localStorage.
const client = axios.create({ baseURL: '/api', withCredentials: true });
if (previewMode) client.defaults.adapter = previewAdapter;
let csrfToken = null;
export function setCsrfToken(value) { csrfToken = value; }
client.interceptors.request.use(async config => {
  if (!['get', 'head', 'options'].includes(config.method || 'get')) {
    if (!csrfToken) {
      const { data } = await client.get('/v1/auth/csrf/');
      csrfToken = data.csrfToken;
    }
    config.headers['X-CSRFToken'] = csrfToken;
  }
  return config;
});
client.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401 && !error.config?.url?.includes('/auth/') && window.location.pathname !== '/login') {
    window.location.assign('/login');
  }
  return Promise.reject(error);
});
export default client;
